module.exports = __webpack_public_path__ + "static/media/ProximaNovaExtrabold.b4f9eb8c.otf";